import { FC } from 'react';
import Button from 'Components/UI/Button';
import Modal from 'Components/UI/Modal';
import { ButtonsContainer, DescriptionContainer } from './styles';

interface IAvisoArquivarObra {
  visible?: boolean;
  nomeObra?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
}

const AvisoArquivarObra: FC<IAvisoArquivarObra> = ({
  visible,
  nomeObra,
  onCancel,
  onConfirm,
}) => {
  const buttons = (
    <ButtonsContainer>
      <span className="link" onClick={onConfirm}>
        Estou ciente e desejo arquivar
      </span>
      <Button className="button" type="primary" height={37} onClick={onCancel}>
        Cancelar
      </Button>
    </ButtonsContainer>
  );

  return (
    <Modal
      title='Atenção'
      footerButtons={buttons}
      visible={visible}
      width={487}
      onCancel={onCancel}
    >
      <DescriptionContainer>
        <div>
          Arquivando a Obra "{nomeObra}" você impossibilita aos
          colaboradores realizarem alterações nos seus arquivos.
        </div>

        <div>Deseja arquivá-la mesmo assim?</div>
      </DescriptionContainer>
    </Modal>
  );
};

export default AvisoArquivarObra;
